/**
 * @desc PAD-根据单号获取已收货box信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(number: string | number, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/pdaReceivingBoxInfo/${number}`, {
      method: "GET",

      ...options,
    }),
  );
}
